/* eslint-disable no-mixed-operators */
import * as React from "react";
import { Dropdown, IDropdownOption } from "@fluentui/react/lib/Dropdown";
import Template from "../../../core/libraries/Template";
import Helper from "../../../core/libraries/Helper";
import Constants from "../../../core/libraries/Constants";
import { connect } from "react-redux";
import _ from "lodash";
import RbLabel, {
  LabelSize,
} from "../../../bosch-react/components/label/RbLabel";
import RbButton, {
  ButtonSize,
  ButtonType,
} from "../../../bosch-react/components/button/RbButton";
import { IUserProfile } from "../../Auth/types";
import { confirmDialog, showDialog, showToastMessage } from "../../Dialog/actions";
import { getDivisionsList } from "../../../services/commonServices";
import AdminWrapper from "../AdminWrapper";
import { withRouter } from "react-router-dom";
import { RootState } from "../../../store/store";
import CustomizedPeoplePicker from "../../../core/components/PeoplePicker/CustomizedPeoplePicker";
import { PrincipalType } from "../../../core/components/PeoplePicker/types";
import { getAllDeptsForGrantAccess, getDocsForGrantAccess, grantAccess } from "../services";
import RbCheckbox from "../../../bosch-react/components/checkbox/RbCheckbox";
import DetailsListWrapper from "../../../core/components/DetailsListWrapper/DetailsListWrapper";
import { ConstrainMode, IColumn, Icon, IconButton, IListProps, SelectionMode, ShimmeredDetailsList, TooltipHost } from "@fluentui/react";
import Configuration from "../../../core/libraries/Configuration";
import RbLink from "../../../bosch-react/components/link/RbLink";
import { IDivision } from "../Managements/Division/types";
import { addAliasDomain, convertPeopleAndGroupObjectArrToStringArr, removeAliasDomain } from "../../../utils/converter";
import { GrantAccessPermission, IGrantAccessDocument, IGrantAccessRequest, IRetrieveDocsReq } from "./types";
import LoadingDialog from "../../../core/components/LoadingDialog";
import NoRecordsFound from "../../../core/components/NoRecordsFound";
import RbLoadingSpinner from "../../../bosch-react/components/loading-spinner/RbLoadingSpinner";
import { tooltipHostStyles } from "../Managements/types";

interface GrantAccessProps {
  userProfile: IUserProfile | undefined;
  confirmDialog: typeof confirmDialog;
  showDialog: typeof showDialog;
  showToastMessage: typeof showToastMessage;
  history: any,
}
interface IState {
  divisionItems: IDropdownOption[],
  departmentList: IDropdownOption[],
  selectedUploadType: string | null,
  selectedDivision: string | null,
  selectedDepartment: string | null,
  selectedSecurityClass: string[],
  isSC2: boolean,
  isSC3: boolean,
  documents: IGrantAccessDocument[] | null,
  filteredDocuments: IGrantAccessDocument[] | null,
  authAssociates: string[] | null,
  authOrgUnits: string[] | null,
  authorizedAssociatesRef: React.RefObject<any>,
  authorizedOrganizationalUnitsRef: React.RefObject<any>
  isRetrivingDocs: boolean,
}

class GrantAccess extends React.Component<GrantAccessProps, IState> {
  constructor(props: GrantAccessProps) {
    super(props);
    this.state = {
      divisionItems: [],
      selectedUploadType: null,
      selectedDivision: null,
      selectedDepartment: null,
      departmentList: [],
      selectedSecurityClass: ['sc2', 'sc3'],
      isSC2: true,
      isSC3: true,
      documents: null,
      filteredDocuments: null,
      authAssociates: null,
      authOrgUnits: null,
      authorizedAssociatesRef: React.createRef(),
      authorizedOrganizationalUnitsRef: React.createRef(),
      isRetrivingDocs: false,
    };
    this.renderUploadType = this.renderUploadType.bind(this);
    this.renderDivision = this.renderDivision.bind(this);
    this.renderDepartmentList = this.renderDepartmentList.bind(this);
    this.renderSecurityClass = this.renderSecurityClass.bind(this);
    this.renderAuthorizedAssociates = this.renderAuthorizedAssociates.bind(this);
    this.renderAuthorizedOrganizationalUnits = this.renderAuthorizedOrganizationalUnits.bind(this);
  }

  async componentDidMount() {
    await this.handleProfileChanged();
  }
  async componentDidUpdate(prevProps: Readonly<GrantAccessProps>, prevState: Readonly<IState>, snapshot?: any) {
    if (prevProps.userProfile !== this.props.userProfile) {
      await this.handleProfileChanged();
    }
  }

  async handleProfileChanged() {
    const { userProfile } = this.props
    if (!!userProfile) {
      if (userProfile.permissions?.isSuperAdmin || userProfile.permissions?.isThesisAdmin || userProfile.permissions?.checkRnDDivisionAdmin?.isAdmin) {
        const divCacheData = Helper.getSessionStorageWithExpiry(Constants.SESSION_STORAGE_KEYS.divisionDropdownItems);
        let divisionMasterList: IDropdownOption[] = [];
        if (!!divCacheData) {
          divisionMasterList = divCacheData as IDropdownOption[];
        }
        else {
          let response = await getDivisionsList();
          let divisions: IDivision[] = !!(response.data) && response.data;
          divisions.forEach((division) => {
            divisionMasterList.push({
              key: division.title || "",
              text: division.longTitle || "",
            });
          });
          divisionMasterList.unshift({ key: "All", text: "--- All ---" });
        }
        !!divisionMasterList && divisionMasterList.length > 0 && this.setState({
          divisionItems: divisionMasterList
        }, () => {
          const { divisionItems } = this.state;
          let selections: IDropdownOption[] = [];
          if (userProfile.permissions?.isSuperAdmin || userProfile.permissions?.isThesisAdmin) {
            selections = [...divisionItems]
          }
          else if (userProfile.permissions?.checkRnDDivisionAdmin?.isAdmin) {
            selections = [...divisionItems]?.filter(item => item.key === userProfile.permissions?.checkRnDDivisionAdmin?.divisionTitle || item.key === userProfile.permissions?.checkRnDDivisionAdmin?.divisionCode)
          }
          else {
            selections = [];
          }
          this.setState({
            divisionItems: selections,
          })
        })
      }
      else {
        /* Access Dialog */
        this.props.confirmDialog(
          Constants.CONFIRMATION_MESSAGE.NO_PERMISSION.TITLE,
          Constants.CONFIRMATION_MESSAGE.NO_PERMISSION.CONTENT,
          true,
          () => {
            window.location.href = process.env.REACT_APP_HOME!;
          }
        );
      }
    }
  }

  columns: IColumn[] = [
    {
      key: 'division', name: 'Division', fieldName: 'Division',
      currentWidth: Helper.resizeColumnByScreenWidth(5),
      minWidth: Helper.resizeColumnByScreenWidth(5),
      isResizable: true,
      onRender: (item: IGrantAccessDocument) => {
        return (<RbLabel size={LabelSize.Small}>{item.division}</RbLabel>);
      }
    },
    {
      key: 'title', name: 'Title', fieldName: 'Title',
      currentWidth: Helper.resizeColumnByScreenWidth(30),
      minWidth: Helper.resizeColumnByScreenWidth(30),
      isResizable: true,
      onRender: (item: IGrantAccessDocument) => {
        return (<RbLink label={item.title} shouldOpenNewTab url={item.accessMediatorPath} />);
      }
    },
    {
      key: 'department', name: 'Department', fieldName: 'Department',
      currentWidth: Helper.resizeColumnByScreenWidth(15),
      minWidth: Helper.resizeColumnByScreenWidth(15),
      isResizable: true,
      onRender: (item: IGrantAccessDocument) => {
        return (
          <RbLabel size={LabelSize.Small}>{item.department}</RbLabel>
        );
      }
    },
    {
      key: 'securityClass', name: 'Security Class', fieldName: 'Security Class',
      currentWidth: Helper.resizeColumnByScreenWidth(15),
      minWidth: Helper.resizeColumnByScreenWidth(15),
      isResizable: true,
      onRender: (item: IGrantAccessDocument) => {
        return (
          <RbLabel size={LabelSize.Small}>{Helper.getSCLongName(item.securityClass)}</RbLabel>
        );
      }
    },
    {
      key: 'action', name: 'Action', fieldName: 'Action',
      currentWidth: Helper.resizeColumnByScreenWidth(10),
      minWidth: Helper.resizeColumnByScreenWidth(10),
      isResizable: true,
      onRender: (item: IGrantAccessDocument) => {
        return (<>
          <RbButton type={ButtonType.Primary} size={ButtonSize.Tiny} label='Update' onClick={async () => {
            const request: IGrantAccessRequest = {
              reportIds: [item.id],
              authorizedUserIds: this.state.authAssociates || [],
              authorizedOrgIds: this.state.authOrgUnits || []
            }
            await this.handleGrantAccess(request)
          }} />
        </>
        );
      }
    },
    {
      key: 'customACL', name: 'Access Control List', fieldName: 'Access Control List',
      currentWidth: Helper.resizeColumnByScreenWidth(15),
      minWidth: Helper.resizeColumnByScreenWidth(15),
      isResizable: true,
      onRender: (item: IGrantAccessDocument) => {
        const peopleAndGroupIds = convertPeopleAndGroupObjectArrToStringArr(item.customAcl)
        const groupIds = peopleAndGroupIds.filter(item => item.length === 36)
        const peopleIds = peopleAndGroupIds.filter(item => item.length !== 36).map(item => addAliasDomain(item))
        return (
          <>
            {!!groupIds && groupIds.length > 0 && Template.renderReadOnlyGroup(groupIds)}
            {!!peopleIds && peopleIds.length > 0 && Template.renderReadOnlyPeople(peopleIds)}
          </>
        );
      }
    },
  ]

  shimmeredDetailsListProps: IListProps = {
    renderedWindowsAhead: 0,
    renderedWindowsBehind: 0,
  };

  render() {
    const { selectedUploadType, isSC3, filteredDocuments, authOrgUnits, authAssociates, isRetrivingDocs } = this.state
    return !!this.props.userProfile && <AdminWrapper history={this.props.history}>
      <div className="ms-Grid">
        <div className="ms-Grid-row">
          <div className="ms-Grid-col ms-sm4">
            <div className="ms-Grid">
              <div className="ms-Grid-row">
                <div className="ms-Grid-col ms-sm12">
                  <RbLabel className="header-title" size={LabelSize.Large}>
                    {" "}
                    Grant Access{" "}
                  </RbLabel>
                  <TooltipHost
                    content={"Because only RnD and Thesis reports need to manage permission by Access Control List for SC2 and SC3 reports. This function would grant mass access for multiple reports."}
                    styles={tooltipHostStyles}
                    calloutProps={{ gapSpace: 10 }}
                  >
                    <IconButton
                      iconProps={{ iconName: "Info" }}
                      ariaLabel="Tab information"
                      title="Tab information"
                    />
                  </TooltipHost>
                </div>
              </div>
              {this.renderUploadType()}
              {this.renderDivision()}
              {this.renderDepartmentList()}
              {!!selectedUploadType && this.renderSecurityClass()}
              {this.renderAuthorizedAssociates()}
              {isSC3 === false && this.renderAuthorizedOrganizationalUnits()}
              <div className="ms-Grid-row">
                <p>
                  <RbButton
                    label="Update all"
                    size={ButtonSize.Small}
                    onClick={async () => {
                      const request: IGrantAccessRequest = {
                        reportIds: filteredDocuments?.map(item => item.id) || [],
                        authorizedUserIds: authAssociates || [],
                        authorizedOrgIds: authOrgUnits || []
                      }
                      await this.handleGrantAccess(request)
                    }}
                  />
                </p>
              </div>
            </div>
          </div>
          <div className="ms-Grid-col ms-sm8">
            {!!isRetrivingDocs ?
              <div style={{ display: "block", width: "100%", height: "5rem", textAlign: "center" }}>
                <RbLoadingSpinner />
              </div> : <DetailsListWrapper>
                {!filteredDocuments || filteredDocuments.length === 0 ? (
                  <NoRecordsFound />
                ) : (
                  <ShimmeredDetailsList
                    setKey="set"
                    compact={true}
                    items={filteredDocuments || []}
                    constrainMode={ConstrainMode.unconstrained}
                    columns={this.columns}
                    enableShimmer={!filteredDocuments}
                    selectionMode={SelectionMode.none}
                    ariaLabelForShimmer="Content is being fetched"
                    ariaLabelForGrid="Pending order details"
                    listProps={this.shimmeredDetailsListProps}
                    onRenderDetailsHeader={Configuration.onRenderStickyDetailsHeader}
                    onShouldVirtualize={() => { return true }}
                  />
                )}
              </DetailsListWrapper>}
          </div>
        </div>
      </div>
    </AdminWrapper>
      || <LoadingDialog />;
  }

  showInvalidRequestDialog() {
    this.props.confirmDialog("Invalid Updating Request", "You must input authorization associates or organization units and the documents must be found in the table on the right side.", true)
  }

  checkPermission = (): GrantAccessPermission => {
    const permissions = this.props.userProfile?.permissions;
    const checking: GrantAccessPermission = {
      isSuperAdmin: permissions?.checkHasPermission([
        Constants.PERMISSIONS.SUPER_ADMIN,
      ]) || false,
      isThesisAdmin: permissions?.checkHasPermission([
        Constants.PERMISSIONS.THESIS_ADMIN,
      ]) || false,
      RnDCoordinator: {
        isCoordinator: permissions?.checkRnDDivisionAdmin?.isAdmin || false,
        ofDivision: permissions?.checkRnDDivisionAdmin?.divisionTitle || ""
      }
    }
    return checking;
  }

  initSecurityClassOptions = () => {
    const { selectedUploadType } = this.state
    let isRnD = selectedUploadType === Constants.UPLOAD_TYPE.RnD;
    this.setState({
      isSC2: true,
      isSC3: isRnD,
      selectedSecurityClass: isRnD ? ['sc2', 'sc3'] : ['sc2']
    })
  }

  initDetailTable = () => {
    this.setState({
      documents: null,
      filteredDocuments: null,
    })
  }

  renderUploadType() {
    const { userProfile } = this.props
    const uploadTypeOptions = userProfile?.permissions?.isSuperAdmin && Constants.DD_UPLOAD_TYPES_GRANT_ACCESS
      || userProfile?.permissions?.isThesisAdmin && [Constants.DD_UPLOAD_TYPES_GRANT_ACCESS[1]]
      || userProfile?.permissions?.checkRnDDivisionAdmin?.isAdmin && [Constants.DD_UPLOAD_TYPES_GRANT_ACCESS[0]] || [];
    return Template.renderCommonTemplate(
      "Upload type",
      <Dropdown
        selectedKey={this.state.selectedUploadType}
        placeholder="Choose upload type ..."
        options={uploadTypeOptions}
        onChange={(event, option) => {
          if (!_.isUndefined(option)) {
            this.initDetailTable();
            this.setState({ selectedUploadType: option.key.toString() }, () => {
              this.initSecurityClassOptions()
            })
          }
        }}
      />,
      false, 4, 8
    );
  }

  renderDivision() {
    const { divisionItems, selectedDivision } = this.state;
    return Template.renderCommonTemplate(
      "Division",
      <Dropdown
        selectedKey={selectedDivision}
        placeholder="Choose division ..."
        options={divisionItems}
        onChange={(event, option) => {
          if (!!option) {
            this.initDetailTable();
            this.setState({ selectedDivision: option.key.toString() }, () => {
              this.handleGetDepsInDivision()
            });
          }
        }}
      />,
      false, 4, 8
    );
  }

  renderSecurityClass() {
    const { selectedUploadType, isSC2, isSC3, selectedSecurityClass } = this.state;
    let isRnD = selectedUploadType === Constants.UPLOAD_TYPE.RnD;
    return Template.renderCommonTemplate(
      "Security Class",
      <>
        <RbCheckbox checked={isSC2} label="2 Confidential" onChange={(newValue?: boolean) => {
          this.setState({
            isSC2: !!newValue,
            selectedSecurityClass: !!newValue ? [...selectedSecurityClass, 'sc2'] : selectedSecurityClass.filter((str) => str !== 'sc2')
          }, () => {
            this.handleChangeSecurityClasses()
          })
        }} />
        {isRnD &&
          <RbCheckbox checked={isSC3} label="3 Strictly Confidential" onChange={(newValue?: boolean) => {
            this.setState({
              isSC3: !!newValue,
              selectedSecurityClass: !!newValue ? [...selectedSecurityClass, 'sc3'] : selectedSecurityClass.filter((str) => str !== 'sc3')
            }, () => {
              this.handleChangeSecurityClasses()
            })
          }} />
        }
      </>,
      false, 4, 8
    );
  }

  checkIsValidRequest = (): boolean => {
    const { selectedUploadType, selectedDivision, selectedDepartment } = this.state
    const isValid = !!selectedDepartment && !!selectedDivision && !!selectedUploadType || false
    return isValid
  }

  handleGetDepsInDivision = async () => {
    const { selectedDivision, selectedUploadType } = this.state
    const departments = !!selectedDivision && !!selectedUploadType && await getAllDeptsForGrantAccess(selectedDivision, selectedUploadType)
    const departmentDropdownItem = !!departments && departments.length > 0 && departments.map(item => {
      return {
        key: item,
        text: item
      } as IDropdownOption
    }) || []
    this.setState({ departmentList: departmentDropdownItem })
  }

  handleChangeSecurityClasses = () => {
    const { documents, selectedSecurityClass } = this.state
    this.setState({
      filteredDocuments: documents?.filter(item => selectedSecurityClass.includes(item.securityClass.toLowerCase())) || []
    })
  }

  handleGetDocs = async () => {
    const { selectedUploadType, selectedDivision, selectedDepartment } = this.state
    try {
      if (this.checkIsValidRequest()) {
        this.initSecurityClassOptions()
        this.setState({ documents: null, filteredDocuments: null, isRetrivingDocs: true })
        const request: IRetrieveDocsReq = {
          uploadType: selectedUploadType!,
          division: selectedDivision!,
          department: selectedDepartment!,
        }
        const documents = await getDocsForGrantAccess(request)
        !!documents && documents.length > 0 && this.setState({
          documents: documents,
          filteredDocuments: documents
        })
      }
    } catch (error) {

    }
    finally {
      this.setState({ isRetrivingDocs: false })
    }
  }

  handleGrantAccess = async (request: IGrantAccessRequest) => {
    if (this.checkIsValidToUpdate()) {
      this.props.showDialog("Updating...")
      const success = await grantAccess(request)
      this.props.showDialog(false)
      this.props.confirmDialog(!!success && "Success" || "Failed", !!success && "Your changes have been saved!" || Constants.MESSAGE_CONTACT_MAILBOX, true)
      !!success && this.handleGetDocs();
    }
    else this.showInvalidRequestDialog();
  }

  renderDepartmentList() {
    return Template.renderCommonTemplate(
      "Department List",
      <Dropdown
        selectedKey={this.state.selectedDepartment}
        placeholder="Choose department list ..."
        disabled={this.state.departmentList.length === 0}
        options={this.state.departmentList}
        onChange={(event, option) => {
          if (!!option) {
            this.setState({ selectedDepartment: option.key.toString() }, () => {
              this.handleGetDocs()
            });
          }
        }}
      />,
      false, 4, 8
    );
  }

  renderAuthorizedAssociates = () => {
    return Template.renderCommonTemplate(
      "Authorized associates",
      <CustomizedPeoplePicker
        onChange={() => { this.onChangeAuthUsers() }}
        componentRef={this.state.authorizedAssociatesRef}
        principalType={PrincipalType.People}
      />,
      false,
      4,
      8
    );
  }

  renderAuthorizedOrganizationalUnits() {
    if (
      !_.isNil(this.state.selectedDepartment)
        ? this.state.selectedDepartment.indexOf("-SC3") === -1
        : true
    ) {
      return Template.renderCommonTemplate(
        "Authorized organizational units",
        <CustomizedPeoplePicker
          onChange={() => { this.onChangeAuthOrgUnits() }}
          componentRef={this.state.authorizedOrganizationalUnitsRef}
          principalType={PrincipalType.Group}
        />,
        false,
        4,
        8
      );
    } else {
      return <span />;
    }
  }

  onChangeAuthUsers() {
    let items = this.state.authorizedAssociatesRef.current.getSelectedItems();
    let results: string[] = [];
    items.forEach((item: any) => {
      !!item.loginName && results.push(removeAliasDomain(item.loginName));
    });
    this.setState({ authAssociates: results })
  }

  onChangeAuthOrgUnits() {
    let items = this.state.authorizedOrganizationalUnitsRef.current.getSelectedItems();
    let results: string[] = [];
    items.forEach((item: any) => {
      !!item.id && results.push(removeAliasDomain(item.id));
    });
    this.setState({ authOrgUnits: results })
  }

  checkIsValidToUpdate() {
    const { selectedSecurityClass, authAssociates, authOrgUnits, filteredDocuments } = this.state
    if (!filteredDocuments || filteredDocuments.length === 0) return false;
    if (selectedSecurityClass.includes('sc3')) {
      this.setState({
        authOrgUnits: null,
      })
      return !!authAssociates && authAssociates.length > 0
    }
    return !!authAssociates && authAssociates.length > 0 || !!authOrgUnits && authOrgUnits.length > 0
  }
}

const mapStateToProps = (state: RootState) => ({
  userProfile: state.auth.userProfile,
});

export default withRouter(connect(mapStateToProps, {
  confirmDialog,
  showDialog,
  showToastMessage,
})(GrantAccess));
